import style from './style';
var boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
export default boxShadow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/system/esm/shadows.js
// module id = 460
// module chunks = 0